import React from 'react';

export default function ErrorMessageField({
  message,
}: {
  message: string;
}): JSX.Element | null {
  return <span className='text-sm text-red-600'>{message}</span>;
}
